import { COUNTRIES } from '../constants/countries';

const allowed = new Set<string>(COUNTRIES as unknown as string[]);

/**
 * Retention / app metrics ülke filtresi: tek seçim.
 * "Tüm Ülkeler" yalnızca tek başına; birden fazla ülke gelirse ilk geçerli ülke kullanılır.
 */
export function normalizeRetentionCountries(input: string[]): string[] {
  const filtered = input.filter((c) => allowed.has(c));
  if (filtered.length === 0) return ['Tüm Ülkeler'];
  if (filtered.includes('Tüm Ülkeler')) return ['Tüm Ülkeler'];
  return [filtered[0]];
}
